export enum Ease {
    None = "none",

    Power1Out = "power1.out",
    Power1In = "power1.in",
    Power1InOut = "power1.inOut",

    Power2Out = "power2.out",
    Power2In = "power2.in",
    Power2InOut = "power2.inOut",

    Power3Out = "power3.out",
    Power3In = "power3.in",
    Power3InOut = "power3.inOut",

    Power4Out = "power4.out",
    Power4In = "power4.in",
    Power4InOut = "power4.inOut",

    BackOut = "back.out(1)",
    BackIn = "back.in(1)",
    BackInOut = "back.inOut(1)",

    BackOut2 = "back.out(2)",
    BackIn2 = "back.in(2)",
    BackInOut2 = "back.inOut(2)",

    ElasticOut = "elastic.out(1, 0.3)",
    ElasticIn = "elastic.in(1, 0.3)",
    ElasticInOut = "elastic.inOut(1, 0.3)",

    BounceOut = "bounce.out",
    BounceIn = "bounce.in",
    BounceInOut = "bounce.inOut",

    Rough = "rough({ strength: 1, points: 20, template: none.out, taper: none, randomize: true, clamp: false })",

    Slow = "slow(0.7, 0.7, false)",

    Steps = "steps(12)",

    CircOut = "circ.out",
    CircIn = "circ.in",
    CircInOut = "circ.inOut",

    ExpoOut = "expo.out",
    ExpoIn = "expo.in",
    ExpoInOut = "expo.inOut",

    SineOut = "sine.out",
    SineIn = "sine.in",
    SineInOut = "sine.inOut",
}